import PageHeader from "@/components/PageHeader";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { StructureAssignmentsForm } from "@/modules/structure-assignments/components/StructureAssignmentsForm";
import { useStructureAssignmentsBreadcrumbs } from "@/modules/structure-assignments/hooks/useStructureAssignmentsBreadcrumbs";
import { useWriteStructureAssignmentsMutation } from "@/modules/structure-assignments/hooks/useWriteStructureAssignmentsMutation";
import { writeStructureAssignment } from "@/schemas/structure-assignment";
import { memo } from "react";
import { useTranslation } from "react-i18next";

export const StructureAssignmentsCreator = memo(() => {
  const { t } = useTranslation();
  const createMutation = useWriteStructureAssignmentsMutation();
  const breadcrumbItems = useStructureAssignmentsBreadcrumbs([
    {
      label: t("structureAssignments.breadcrumb.create"),
    },
  ]);
  const { can_create } = useModulePermissions();

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <StructureAssignmentsForm
        mutation={createMutation}
        schema={writeStructureAssignment}
        disabled={!can_create}
      />
    </>
  );
});
